module.exports = __webpack_public_path__ + "assets/ed171e1fe90875208cc5c93dee73603d.mp3";